import BlokWrap from "@/components/ui/BlokWrap";
import { QuoteStoryblok } from "@/generated/sb/sb-types";
import { BlokProps } from "@frend-digital/storyblok";
import clsx from "clsx";
import styles from "./index.module.css";

export const Quote = ({
  blok,
  column,
}: BlokProps<QuoteStoryblok> & {
  column?: boolean;
}) => {
  return (
    <BlokWrap data-layout="page" animated="fadeY" editorial editable={blok}>
      <div className={clsx(styles.wrapper, column && styles.column)}>
        <div className={styles.inner}>
          <blockquote className={styles.quote}>
            <p>{blok.text}</p>
            <cite>{blok.cite}</cite>
          </blockquote>
        </div>
      </div>
    </BlokWrap>
  );
};
